'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = required;
exports.positiveInt = positiveInt;
exports.positiveDecimal = positiveDecimal;
exports.cellphone = cellphone;
exports.idCard = idCard;
exports.price = price;
exports.email = email;
exports.ip = ip;
/**
 * validator
 * 常用的一些验证
 */

/**
 * 必填
 * @param {String} str
 * @return {Boolean}
 */
function required(str) {
  if (str) {
    return !!str.length;
  }
  return false;
}

/**
 * 正整数 （包含0）
 * @param {String} str
 * @return {Boolean}
 */
function positiveInt(str) {
  if (str) {
    return (/^([1-9]\d*|[0]{1,1})$/.test(str)
    );
  }
  return true;
}

/**
 * 正浮点数（包含0）
 * @param {String} str
 * @return {Boolean}
 */
function positiveDecimal(str) {
  if (str) {
    return (/^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/.test(str)
    );
  }
  return true;
}

/**
 * 手机号
 * 11位
 * 13段：130、131、132、133、134、135、136、137、138、139
 * 14段：145、147
 * 15段：150、151、152、153、155、156、157、158、159
 * 17段：170、176、177、178
 * 18段：180、181、182、183、184、185、186、187、188、189
 * @param {String} str
 * @return {Boolean}
 */
function cellphone(str) {
  if (str) {
    return (/^(((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9]))+\d{8})$/.test(str)
    );
  }
  return true;
}

/**
 * 大陆身份证号码
 * @param {String} str
 * @return {Boolean}
 */
function idCard(str) {
  if (str) {
    str = str.toString();
    var reg = void 0,
        length = str.length;
    if (length === 15) {
      reg = new RegExp(/^(\d{6})()?(\d{2})(\d{2})(\d{2})(\d{2})(\w)$/);
    } else if (length === 18) {
      reg = new RegExp(/^(\d{6})()?(\d{4})(\d{2})(\d{2})(\d{3})(\w)$/);
    } else {
      return false;
    }
    var regMatch = str.match(reg);
    if (regMatch != null) {
      var a = void 0,
          r = void 0;
      if (length === 15) {
        a = new Date('19' + regMatch[3] + '/' + regMatch[4] + '/' + regMatch[5]);
        r = a.getYear() == regMatch[3] && a.getMonth() + 1 == regMatch[4] && a.getDate() == regMatch[5];
      } else {
        a = new Date(regMatch[3] + '/' + regMatch[4] + '/' + regMatch[5]);
        r = a.getFullYear() == regMatch[3] && a.getMonth() + 1 == regMatch[4] && a.getDate() == regMatch[5];
      }
      return r;
    }
    return reg.test(str);
  }
  return true;
}

/**
 * 价格 大于0的浮点数
 * @param {String} value
 */
function price(value) {
  if (value) {
    value = value.toString();
    if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
      return false;
    }
  }
  return true;
}

/**
 * 邮箱
 * 1.邮箱以a-z、A-Z、0-9开头，最小长度为1.
 * 2.如果左侧部分包含-、_、.则这些特殊符号的前面必须包一位数字或字母。
 * 3.@符号是必填项
 * 4.右则部分可分为两部分，第一部分为邮件提供商域名地址，第二部分为域名后缀，现已知的最短为2位。最长的为6为。
 * 5.邮件提供商域可以包含特殊字符-、_、.
 * @param {String} str
 * @return {Boolean}
 */
function email(str) {
  if (str) {
    return (/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(str)
    );
  }
  return true;
}

/**
 * ip
 * ipv4、ipv6
 * "192.168.0.0"
 * "192.168.2.3.1.1"
 * "235.168.2.1"
 * "192.168.254.10"
 * "192.168.254.10.1.1"
 * @param {String} str
 * @return {Boolean}
 */
function ip(str) {
  if (str) {
    return (/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])((\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){3}|(\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){5})$/.test(str)
    );
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/validator.js
// module id = 42
// module chunks = 0